import { useState, useEffect } from 'react'

interface BrowserInfo {
    name: string
    version: string
    isSafari: boolean
}
/**
 * Custom hook for browser detection
 * @returns {Object} Browser information object containing name, version, and isSafari flag
 */
export const useBrowserInfo = (): BrowserInfo => {
    const [browserInfo, setBrowserInfo] = useState<BrowserInfo>({
        name: '',
        version: '',
        isSafari: false,
    })

    useEffect(() => {
        const detectBrowser = () => {
            const userAgent = navigator.userAgent
            let browserName = 'Unknown'
            let browserVersion = 'Unknown'
            let isSafari = false

            // Detect Safari (not supported)
            if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
                browserName = 'Safari'
                isSafari = true
                const safariMatch = userAgent.match(/Version\/(\d+\.\d+)/)
                if (safariMatch) {
                    browserVersion = safariMatch[1]
                }
            }
            // Detect Edge (Chromium-based, supported)
            else if (userAgent.includes('Edg')) {
                browserName = 'Edge'
                const edgeMatch = userAgent.match(/Edg\/(\d+\.\d+)/)
                if (edgeMatch) {
                    browserVersion = edgeMatch[1]
                }
            }
            // Detect Chrome (supported)
            else if (userAgent.includes('Chrome')) {
                browserName = 'Chrome'
                const chromeMatch = userAgent.match(/Chrome\/(\d+\.\d+)/)
                if (chromeMatch) {
                    browserVersion = chromeMatch[1]
                }
            }
            // Detect Firefox (supported)
            else if (userAgent.includes('Firefox')) {
                browserName = 'Firefox'
                const firefoxMatch = userAgent.match(/Firefox\/(\d+\.\d+)/)
                if (firefoxMatch) {
                    browserVersion = firefoxMatch[1]
                }
            }
            
            setBrowserInfo({ name: browserName, version: browserVersion, isSafari })
        }
        
        detectBrowser()
    }, []) 

    return browserInfo
}
